import { createEntityAdapter } from '@reduxjs/toolkit';
import { IValveConnectorGridEdit } from 'application/editcomp/api/ValveConnectorGrid/ValveConnectorGridEdit';

export const valveConnectorGridEditAdapter = createEntityAdapter<IValveConnectorGridEdit, number>({
  selectId: (project) => project.valveConnectorGridID,
  //sortComparer: (a, b) => a.valveConnector.localeCompare(b.valveConnector),
});
